import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';
import { IMAGE_URL } from '../../path';
import AdminLayout from './Components/AdminLayout';
import RangeModal from "./Components/RangeModal";
import ProductModal from "./Components/ProductModal";

export default function RangePage()
{
    const [page, setPage] =
        useState<any>(null);

    const [coverImage, setCoverImage] =
        useState<File | null>(null);

    const [coverPreview, setCoverPreview] =
        useState('');

    const [headerBody, setHeaderBody] =
        useState('');

    const [saving, setSaving] =
        useState(false);

    const [ranges, setRanges] =
        useState<any[]>([]);

    const [rangeModalOpen, setRangeModalOpen] =
        useState(false);

    const [selectedRange, setSelectedRange] =
        useState<any>(null);

    const [bestServedWith, setBestServedWith] =
        useState<any[]>([]);

    const [products, setProducts] =
        useState<any[]>([]);

    const [productModalOpen, setProductModalOpen] =
        useState(false);

    const [selectedProduct, setSelectedProduct] =
        useState<any>(null);


    useEffect(() => {

        loadPage();

    }, []);

    const getImageUrl = (
        path?: string
    ) => {

        if (!path) {
            return '';
        }

        if (
            path.startsWith(
                'http'
            )
        ) {
            return path;
        }

        return `${IMAGE_URL}${path}`;
    };

    const loadPage = async () => {

        try {

            const response =
                await api.get('/page-header/range');

            const rangesResponse =
                await api.get(
                    '/ranges'
                );

            const bestServedWithResponse =
                await api.get(
                    "/best-served-with"
                );

            const productsResponse =
                await api.get(
                    '/products'
                );

            setProducts(
                productsResponse.data
            );

            setRanges(
                rangesResponse.data
            );

            const data = response.data.page;

            setPage(
                data
            );

            setHeaderBody(
                data?.header_body || ''
            );

            if (
                data?.cover_image
            ) {

                setCoverPreview(
                    getImageUrl(
                        data.cover_image
                    )
                );
            }

            setBestServedWith(
                bestServedWithResponse.data.best_served_with
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    const handleSaveRange = async (
        data: any
    ) => {

        try {

            const formData =
                new FormData();

            formData.append(
                'name',
                data.name
            );

            formData.append(
                'display_name',
                data.display_name
            );

            formData.append(
                'short_description',
                data.short_description
            );

            formData.append(
                'header_body',
                data.header_body || ''
            );

            if (data.header_image) {

                formData.append(
                    'header_image',
                    data.header_image
                );

            }

            formData.append(
                'is_active',
                data.is_active ? '1' : '0'
            );

            if (data.cover_image) {

                formData.append(
                    'cover_image',
                    data.cover_image
                );

            }

            if (selectedRange) {

                await api.post(

                    `/ranges/${selectedRange.id}?_method=PUT`,

                    formData,

                    {
                        headers: {
                            'Content-Type':
                                'multipart/form-data',
                        },
                    }

                );

            } else {

                await api.post(

                    '/ranges',

                    formData,

                    {
                        headers: {
                            'Content-Type':
                                'multipart/form-data',
                        },
                    }

                );

            }

            setRangeModalOpen(
                false
            );

            setSelectedRange(
                null
            );

            await loadPage();

        } catch (
            error
            ) {

            console.error(
                error
            );

            alert(
                'Failed to save range.'
            );

        }
    };

    const handleSaveProduct = async (
        data: FormData
    ) => {

        try {

            if (
                selectedProduct
            ) {

                await api.post(

                    `/products/${selectedProduct.id}?_method=PUT`,

                    data,

                    {
                        headers: {
                            'Content-Type':
                                'multipart/form-data',
                        },
                    }

                );

            } else {

                await api.post(

                    '/products',

                    data,

                    {
                        headers: {
                            'Content-Type':
                                'multipart/form-data',
                        },
                    }

                );
            }

            setProductModalOpen(
                false
            );

            setSelectedProduct(
                null
            );

            await loadPage();

        } catch (
            error: any
            ) {

            console.error(
                error
            );

            alert(

                error?.response?.data?.message ||

                'Failed to save product.'

            );

        }
    };

    const handleDeleteProduct = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this product?'
            )
        ) {
            return;
        }

        await api.delete(
            `/products/${id}`
        );

        await loadPage();
    };

    const handleDeleteRange = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this range?'
            )
        ) {
            return;
        }

        try {

            await api.delete(
                `/ranges/${id}`
            );

            await loadPage();

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    const moveRangeUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...ranges];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setRanges(
            updated
        );

        try {

            await api.post(
                '/ranges/reorder',
                {
                    ranges:
                        updated.map(
                            (
                                range,
                                position
                            ) => ({
                                id:
                                range.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    const moveProductUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...products];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setProducts(
            updated
        );

        try {

            await api.post(
                '/products/reorder',
                {
                    products:
                        updated.map(
                            (
                                product,
                                position
                            ) => ({
                                id:
                                product.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

            await loadPage();

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    const moveRangeDown = async (
        index: number
    ) => {

        if (
            index >=
            ranges.length - 1
        ) {
            return;
        }

        const updated =
            [...ranges];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setRanges(
            updated
        );

        try {

            await api.post(
                '/ranges/reorder',
                {
                    ranges:
                        updated.map(
                            (
                                range,
                                position
                            ) => ({
                                id:
                                range.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    const moveProductDown = async (
        index: number
    ) => {

        if (
            index >=
            products.length - 1
        ) {
            return;
        }

        const updated =
            [...products];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setProducts(
            updated
        );

        try {

            await api.post(
                '/products/reorder',
                {
                    products:
                        updated.map(
                            (
                                product,
                                position
                            ) => ({
                                id:
                                product.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

            await loadPage();

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };
    const handleSave = async () => {

        try {

            setSaving(
                true
            );

            if (
                coverImage
            ) {

                const formData =
                    new FormData();

                formData.append(
                    'image',
                    coverImage
                );

                await api.post(
                    '/page-header/range/cover-image',
                    formData
                );
            }

            await api.put(
                '/page-header/range/header-body',
                {
                    header_body:
                    headerBody,
                }
            );

            await loadPage();

            setCoverImage(
                null
            );

            alert(
                'Range page updated successfully.'
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

            alert(
                'Failed to save changes.'
            );

        } finally {

            setSaving(
                false
            );

        }
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Range Page
                </h1>

                <button
                    className="action-btn"
                    onClick={
                        handleSave
                    }
                    disabled={
                        saving
                    }
                >
                    {
                        saving
                            ? 'Saving...'
                            : 'Save Changes'
                    }
                </button>

            </div>

            <div className="admin-card">

                <h2>
                    Cover Image
                </h2>

                {coverPreview && (

                    <img
                        src={
                            coverPreview
                        }
                        alt=""
                        className="image-preview"
                    />

                )}

                <p className="field-hint">
                    Maximum file size: 2MB
                </p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {

                        const file =
                            e.target.files?.[0];

                        if (!file) {
                            return;
                        }

                        if (
                            file.size >
                            2 * 1024 * 1024
                        ) {

                            alert(
                                'Image must be 2MB or smaller.'
                            );

                            return;
                        }

                        setCoverImage(
                            file
                        );

                        setCoverPreview(
                            URL.createObjectURL(
                                file
                            )
                        );

                    }}
                />

            </div>

            <div className="admin-card description">

                <label>
                    Header Body
                </label>

                <textarea
                    value={
                        headerBody
                    }
                    onChange={(e) =>
                        setHeaderBody(
                            e.target.value
                        )
                    }
                    rows={8}
                    className="form-control"
                />

            </div>

            <div className="admin-card">

                <div className="page-header">

                    <h2>
                        Ranges
                    </h2>

                    <button
                        className="action-btn"
                        onClick={() => {

                            setSelectedRange(
                                null
                            );

                            setRangeModalOpen(
                                true
                            );

                        }}
                    >
                        Add Range
                    </button>

                </div>

                <table className="users-table">

                    <thead>

                    <tr>

                        <th className="users-name">
                            Name
                        </th>

                        <th>
                            Active Products
                        </th>

                        <th>
                            Active
                        </th>

                        <th>
                            Actions
                        </th>

                    </tr>

                    </thead>

                    <tbody>

                    {ranges.map(
                        (
                            range,
                            index
                        ) => (

                            <tr
                                key={
                                    range.id
                                }
                            >

                                <td>
                                    {
                                        range.display_name
                                    }
                                </td>
                                <td>
                                    {
                                        range.active_products_count
                                    }
                                </td>

                                <td>
                                    {
                                        range.is_active
                                            ? 'Yes'
                                            : 'No'
                                    }
                                </td>

                                <td>

                                    <div className="actions">

                                        <button
                                            className="edit-btn"
                                            onClick={() =>
                                                moveRangeUp(
                                                    index
                                                )
                                            }
                                        >
                                            ▲
                                        </button>

                                        <button
                                            className="edit-btn"
                                            onClick={() =>
                                                moveRangeDown(
                                                    index
                                                )
                                            }
                                        >
                                            ▼
                                        </button>

                                        <button
                                            className="edit-btn"
                                            onClick={() => {

                                                setSelectedRange(
                                                    range
                                                );

                                                setRangeModalOpen(
                                                    true
                                                );

                                            }}
                                        >
                                            Edit
                                        </button>

                                        <button
                                            className="delete-btn"
                                            onClick={() =>
                                                handleDeleteRange(
                                                    range.id
                                                )
                                            }
                                        >
                                            Delete
                                        </button>

                                    </div>

                                </td>

                            </tr>

                        )
                    )}

                    </tbody>

                </table>

            </div>

            <div className="admin-card">

                <div className="page-header">

                    <h2>
                        Products
                    </h2>

                    <button
                        className="action-btn"
                        onClick={() => {

                            setSelectedProduct(
                                null
                            );

                            setProductModalOpen(
                                true
                            );

                        }}
                    >
                        Add Product
                    </button>

                </div>

                <table className="users-table">

                    <thead>

                    <tr>

                        <th>
                            Name
                        </th>

                        <th>
                            Flavour
                        </th>

                        <th>
                            Active
                        </th>

                        <th>
                            Actions
                        </th>

                    </tr>

                    </thead>

                    <tbody>

                    {products.map(
                        (
                            product,
                            index
                        ) => (

                            <tr
                                key={
                                    product.id
                                }
                            >

                                <td>
                                    {
                                        product.name
                                    }
                                </td>

                                <td>
                                    {
                                        product.flavour
                                    }
                                </td>

                                <td>
                                    {
                                        product.is_active
                                            ? 'Yes'
                                            : 'No'
                                    }
                                </td>

                                <td>

                                    <div className="actions">

                                        <button
                                            className="edit-btn"
                                            onClick={() =>
                                                moveProductUp(
                                                    index
                                                )
                                            }
                                        >
                                            ▲
                                        </button>

                                        <button
                                            className="edit-btn"
                                            onClick={() =>
                                                moveProductDown(
                                                    index
                                                )
                                            }
                                        >
                                            ▼
                                        </button>

                                        <button
                                            className="edit-btn"
                                            onClick={() => {

                                                setSelectedProduct(
                                                    product
                                                );

                                                setProductModalOpen(
                                                    true
                                                );

                                            }}
                                        >
                                            Edit
                                        </button>

                                        <button
                                            className="delete-btn"
                                            onClick={() =>
                                                handleDeleteProduct(
                                                    product.id
                                                )
                                            }
                                        >
                                            Delete
                                        </button>

                                    </div>

                                </td>

                            </tr>

                        )
                    )}

                    </tbody>

                </table>

            </div>

            {
                rangeModalOpen && (

                    <RangeModal

                        range={
                            selectedRange
                        }

                        onClose={() => {

                            setRangeModalOpen(
                                false
                            );

                            setSelectedRange(
                                null
                            );

                        }}

                        onSave={
                            handleSaveRange
                        }

                    />

                )
            }

            {
                productModalOpen && (

                    <ProductModal

                        product={
                            selectedProduct
                        }

                        bestServedWith={bestServedWith}

                        ranges={
                            ranges
                        }

                        onClose={() => {

                            setProductModalOpen(
                                false
                            );

                            setSelectedProduct(
                                null
                            );

                        }}

                        onSave={
                            handleSaveProduct
                        }

                    />

                )
            }



        </AdminLayout>

    );
}
